module.exports = __webpack_public_path__ + "img/telehealth-woman-baby-doctor-cropped@3x.dd324f48.png";